/* Klaviyo laaser sidens scroll for en popup der aldrig bliver synlig.
 *
 * Klaviyo saetter klassen "klaviyo-prevent-body-scrolling" paa <body>, og deres
 * eget stylesheet har:
 *     body.klaviyo-prevent-body-scrolling { overflow: hidden !important; }
 * Naar popup'en bliver blokeret eller forsinket - fx af en samtykke-loesning -
 * bliver klassen haengende, uden at der er noget at se. Resultatet er en side
 * der ikke kan scrolles paa mobil.
 *
 * Denne sikring fjerner klassen, men KUN naar der faktisk ikke er en synlig
 * Klaviyo-formular. Er popup'en aaben og synlig, lader vi laasen staa, saa
 * formularen stadig virker som den skal.
 *
 * Det er en midlertidig afhjaelpning. Den rigtige loesning er at rette op paa
 * den popup i Klaviyo, der udloeser laasen.
 */
(function () {
  var KLASSE = 'klaviyo-prevent-body-scrolling';

  function synligPopup() {
    var kandidater = document.querySelectorAll(
      '.klaviyo-form, [class*="kl-private-reset-css"], [data-testid="klaviyo-form"]'
    );
    for (var i = 0; i < kandidater.length; i++) {
      var el = kandidater[i];
      var r = el.getBoundingClientRect();
      if (r.width < 40 || r.height < 40) continue;
      var c = getComputedStyle(el);
      if (c.display === 'none' || c.visibility === 'hidden' || parseFloat(c.opacity) === 0) continue;
      return true;
    }
    return false;
  }

  function tjek() {
    if (!document.body || !document.body.classList.contains(KLASSE)) return;
    if (synligPopup()) return;
    document.body.classList.remove(KLASSE);
  }

  function start() {
    tjek();
    // Klaviyo kan saette klassen igen senere, saa vi lytter paa aendringer.
    new MutationObserver(function () {
      // lille forsinkelse, saa popup'en naar at blive tegnet foer vi vurderer
      window.setTimeout(tjek, 150);
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // sikkerhedsnet de foerste sekunder, hvor tredjeparts-scripts loader
    var n = 0;
    var t = window.setInterval(function () {
      tjek();
      if (++n > 20) window.clearInterval(t);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
